import { HStack } from '@cad-arc';
import { EventSearchForm } from '@mark43/cad-api';
import { EventInformationFiltersSummary } from './event-information-filters-summary';
import { EventLocationFiltersSummary } from './event-location-filters-summary';
import { OtherFiltersSummary } from './other-filters-summary';
import { PersonInformationFiltersSummary } from '../search-windows/person-information-filters-summary';
import { VehicleInformationFiltersSummary } from '../search-windows/vehicle-information-filters-summary';
import { InvolvedItemsInformationFiltersSummary } from '../search-windows/involved-items-information-filters-summary';

export function EventSearchResultsAppliedFilters({
    eventSearchForm,
}: {
    eventSearchForm: EventSearchForm;
}) {
    return (
        <HStack
            justifyContent="space-between"
            alignItems="flex-start"
            backgroundColor="surface.background"
            w="100%"
            padding="24px var(--arc-space-14)"
        >
            <EventInformationFiltersSummary eventSearchForm={eventSearchForm} />
            <EventLocationFiltersSummary eventSearchForm={eventSearchForm} />
            <PersonInformationFiltersSummary persons={eventSearchForm.persons} />
            <VehicleInformationFiltersSummary
                vehicles={eventSearchForm.vehicles}
                hasHeldTowVehicle={eventSearchForm.hasHeldTowVehicle?.value}
                hasReleasedTowVehicle={eventSearchForm.hasReleasedTowVehicle?.value}
            />
            <InvolvedItemsInformationFiltersSummary involvedItems={eventSearchForm.involvedItems} />
            <OtherFiltersSummary eventSearchForm={eventSearchForm} />
        </HStack>
    );
}
